import { useContext } from 'react';
import { CurrentEnterpriseContext } from './currentEnterpriseContext';

export function useCurrentEnterprise() {
    const currentEnterpriseContext = useContext(CurrentEnterpriseContext);
    if (!currentEnterpriseContext) {
        throw new Error('useCurrentEnterprise must be wrapped in a CurrentEnterpriseProvider');
    }
    return currentEnterpriseContext;
}
